export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11914.7a0a062b.jpg";